<div class="text-center pb-4">
  <div *ngIf="deviceDetectorService.isMobile() && tituloLogoPjusService.model?.urlImagemMobile">
    <img [src]="tituloLogoPjusService.model?.urlImagemMobile" alt="" class="w-100">
  </div>
  <div *ngIf="!deviceDetectorService.isMobile() && tituloLogoPjusService.model?.urlImagem">
    <img [src]="tituloLogoPjusService.model?.urlImagem" alt="" class="w-100">
  </div>
  <div class="w-100 mt-3">
    <a *ngIf="tituloLogoPjusService.model?.opcaoVoltar"
       class="text-decoration-none d-flex align-items-center position-absolute"
       [routerLink]="tituloLogoPjusService.model?.routerLink"
    >
      <span class="material-symbols-outlined text-black ms-2">
        arrow_back
      </span>
      <span class="texto-secundario texto-inter ms-2" *ngIf="tituloLogoPjusService.model?.exibirLabelVoltar">
        Voltar
      </span>
    </a>
    <h5 *ngIf="tituloLogoPjusService.model?.titulo"
        class="texto-cor-primario texto-inter mb-0">
      {{ tituloLogoPjusService.model?.titulo }}
    </h5>
  </div>
</div>
